export default __webpack_public_path__ + "static/media/eldur.acddfe8f.jpg";